module.exports = __webpack_public_path__ + "static/media/Table2_After.75780a9d.jpg";